import { Box, keyframes, styled } from '@migros/msrc-ui-kit';
const loadingAnimation = keyframes`
  100% {
    transform: translateX(100%);
  }
`;
export const SkeletonBox = styled(Box)`
  background: rgba(0, 0, 0, 0.12);
  width: 100%;
  height: 100%;
  border-radius: ${({
  theme
}) => theme.borderRadiuses.small};
  overflow: hidden;
  position: relative;

  &:after {
    animation: ${loadingAnimation} 1.2s linear infinite;
    transform: translateX(-100%);
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
  }
`;